import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
  username: Yup.string().email('Invalid email address').required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
});

export const resetPasswordValidationSchema = Yup.object({
  first_name: Yup.string().trim().required('First name is required'),
  last_name: Yup.string().trim().required('Last name is required'),
  new_password: Yup.string()
    .required('New password is required')
    .min(8, 'New password must be at least 8 characters long')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)'
    ),
  confirm_new_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], 'Passwords must match')
    .required('Please confirm your new password'),
});

export type ResetPasswordFormValues = Yup.InferType<typeof resetPasswordValidationSchema>;

export const forgotPasswordRequestValidationSchema = Yup.object({
  username: Yup.string().email('Invalid email address').required('Email is required'),
});

export type ForgotPasswordRequestFormValues = Yup.InferType<
  typeof forgotPasswordRequestValidationSchema
>;

export const forgotPasswordConfirmValidationSchema = Yup.object({
  confirmation_code: Yup.string().trim().required('Confirmation code is required'),
  new_password: Yup.string()
    .required('New password is required')
    .min(8, 'New password must be at least 8 characters long')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)'
    ),
  confirm_new_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], 'Passwords must match')
    .required('Please confirm your new password'),
});

export type ForgotPasswordConfirmFormValues = Yup.InferType<
  typeof forgotPasswordConfirmValidationSchema
>;
